import { ArrowLeft, Clock } from "lucide-react";
import { Link } from "react-router";

import { LOCAL_CHAPTERS } from "@/components/guide/local/chapters";
import { Tutorial } from "@/components/guide/tutorial";
import { GUIDES, otherGuides } from "@/lib/guides";
import { GuideCard } from "@/routes/guidelines/index";

const SELF = "/guidelines/local";

/**
 * The second guide: the simulator on the reader's own machine. Same shape as the tutorial
 * (steps down the left, a preview that follows), without the hero: a reader here has done
 * the tutorial and wants the next thing, not a welcome.
 */
export function LocalGuideRoute() {
  const guide = GUIDES.find((g) => g.to === SELF);
  return (
    <div className="guide space-y-10">
      <header className="mx-auto max-w-3xl space-y-3">
        <Link
          to="/guidelines"
          className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1 text-sm"
        >
          <ArrowLeft className="size-3.5" aria-hidden />
          Guides
        </Link>
        <h1 className="text-3xl font-semibold tracking-tight">On your own machine</h1>
        <p className="text-muted-foreground text-base leading-7">
          The simulator behind every challenge, as a Python package in your own process: practice
          on any maze without spending attempts, look at the truth while you debug, and generate
          as many mazes as you like. Everything you write for it runs on the server unchanged.
          The last chapter is an experimental reinforcement learning demo; the tutorial&apos;s
          baseline stays the reference agent.
        </p>
        {guide?.minutes ? (
          <p className="text-muted-foreground inline-flex items-center gap-1 text-xs">
            <Clock className="size-3" aria-hidden />
            {guide.minutes} minutes · {LOCAL_CHAPTERS.length} chapters · after the tutorial
          </p>
        ) : null}
      </header>
      <Tutorial chapters={LOCAL_CHAPTERS}>
        <section aria-labelledby="more-title" className="scroll-mt-28">
          <h2 id="more-title" className="text-2xl font-semibold tracking-tight">
            Other guides
          </h2>
          <div className="mt-6 grid gap-3">
            {otherGuides(SELF).map((g) => (
              <GuideCard key={g.to} guide={g} />
            ))}
          </div>
        </section>
      </Tutorial>
    </div>
  );
}
